export default __webpack_public_path__ + "static/media/login3.58918d69.png";